<div class="modal-header border-0" [class.bg-neutral-50]="modalMode">
  <h4 class="modal-title">Save Custom Filter</h4>
  <button type="button" class="close" aria-label="Close" (click)="Close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body border-0" [class.bg-neutral-25]="modalMode" [class.componentMode]="!modalMode" style="max-height: 80vh;">
  <input type="text" class="bg-neutral-25 p-2" style="width: 20rem;" (change)="check($event)" placeholder="Enter a name for your filter">
</div>
<div class="modal-footer border-0 pt-0" [class.bg-neutral-50]="modalMode">
  <div class="row w-100">
    <div class="col-6 p-0">
      <button type="button" class="btn btn-primary btn-red p-2 mt-2" (click)="Save()">Apply</button>
    </div>
  </div>
</div>
